// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"pen"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15.0001 3L13.9376 5.125C13.015 6.97006 11.4154 8.38744 9.47275 9.08121L5.49988 10.5L4 20.0001L13.5 18.5001L14.9189 14.5273C15.6127 12.5847 17.03 10.9851 18.8751 10.0626L21 9.00012M4.50012 19.5L11 13.0001","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const PenIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'pen',
    ref,
    icon: element,
  },
));

PenIcon.displayName = 'PenIcon';

export default PenIcon;
